export default __webpack_public_path__ + "e4dacffcdad0e2d1accbfdac29d77803.png";